import { render } from "./FeedTheAnimal.vue?vue&type=template&id=08e564c6&scoped=true"
import script from "./FeedTheAnimal.vue?vue&type=script&lang=js"
export * from "./FeedTheAnimal.vue?vue&type=script&lang=js"

import "./FeedTheAnimal.vue?vue&type=style&index=0&id=08e564c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e564c6"]])

export default __exports__